import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'

const canvas = document.querySelector('canvas.webgl')
const scene = new THREE.Scene()

const rgbeLoader = new THREE.CubeTextureLoader()
const environmentMap = rgbeLoader.load([
    'https://threejs.org/examples/textures/cube/Park3Med/px.jpg',
    'https://threejs.org/examples/textures/cube/Park3Med/nx.jpg',
    'https://threejs.org/examples/textures/cube/Park3Med/py.jpg',
    'https://threejs.org/examples/textures/cube/Park3Med/ny.jpg',
    'https://threejs.org/examples/textures/cube/Park3Med/pz.jpg',
    'https://threejs.org/examples/textures/cube/Park3Med/nz.jpg'
])
scene.environment = environmentMap
scene.background = environmentMap

const ambientLight = new THREE.AmbientLight(0xffffff, 0.5)
scene.add(ambientLight)

const pointLight = new THREE.PointLight(0xffffff, 50)
pointLight.position.set(10, 20, 15)
scene.add(pointLight)

const objects = []
const count = 200

function createObjects() {
    const minDistance = 2.0

    for (let i = 0; i < count; i++) {
        const randomColor = new THREE.Color().setHSL(Math.random(), 0.7, 0.5)

        const object = new THREE.Mesh(
            new THREE.SphereGeometry((Math.random() + 0.3) * 2, 64, 64),
            new THREE.MeshPhysicalMaterial({
                color: randomColor,
                metalness: 0.1,
                roughness: 0.05,
                transmission: 0.5,
                thickness: 0.5,
                clearcoat: 1.0,
                clearcoatRoughness: 0.1
            })
        )

        let isValid = false
        let attempts = 0

        while (!isValid && attempts < count) {
            object.position.set(
                (Math.random() - 0.5) * 50,
                (Math.random() - 0.5) * 50,
                (Math.random() - 0.5) * 50
            )

            isValid = true
            for (const other of objects) {
                if (object.position.distanceTo(other.position) < minDistance) {
                    isValid = false
                    break
                }
            }
            attempts++
        }

        object.basePosition = object.position.clone()
        object.offset = Math.random() * Math.PI * 2
        objects.push(object)
        scene.add(object)
    }
}

createObjects()

const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}

window.addEventListener('resize', () => {
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})

const camera = new THREE.PerspectiveCamera(75, sizes.width / sizes.height, 0.1, 100)
camera.position.z = 50
scene.add(camera)

const controls = new OrbitControls(camera, canvas)
controls.target.set(0, 0, 0)
controls.enableRotate = false
controls.enableZoom = false
controls.enablePan = false
controls.update()

let azimuth = 0
let polar = Math.PI / 2
const radius = 50
const rotateSpeed = 0.03

const keys = {}
window.addEventListener('keydown', (e) => { keys[e.code] = true })
window.addEventListener('keyup', (e) => { keys[e.code] = false })

const renderer = new THREE.WebGLRenderer({ canvas: canvas, antialias: true })
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
renderer.toneMapping = THREE.ACESFilmicToneMapping
renderer.outputColorSpace = THREE.SRGBColorSpace

const raycaster = new THREE.Raycaster()
const mouse = new THREE.Vector2()

window.addEventListener('mousemove', (event) => {
    mouse.x = (event.clientX / window.innerWidth) * 2 - 1
    mouse.y = -(event.clientY / window.innerHeight) * 2 + 1
})

const clock = new THREE.Clock()
let currentIntersect = null

let score = 0
const scoreElement = document.getElementById('score')

window.addEventListener('click', () => {
    document.body.classList.remove('shoot-anim')
    void document.body.offsetWidth
    document.body.classList.add('shoot-anim')

    if (!currentIntersect) return

    const clickedObj = currentIntersect.object
    createExplosion(clickedObj.position, clickedObj.material.color)

    const flash = new THREE.PointLight(0xffffff, 100, 10)
    flash.position.copy(camera.position)
    scene.add(flash)
    setTimeout(() => scene.remove(flash), 50)

    score++
    scoreElement.innerText = `HITS: ${score}`

    scene.remove(clickedObj)
    const index = objects.indexOf(clickedObj)
    if (index > -1) objects.splice(index, 1)

    currentIntersect = null
})

const resetBtn = document.getElementById('reset-btn')
resetBtn.addEventListener('click', () => {
    score = 0
    scoreElement.innerText = `HITS: ${score}`

    for (const obj of objects) {
        scene.remove(obj)
        obj.geometry.dispose()
        obj.material.dispose()
    }

    objects.length = 0
    createObjects()
    resetBtn.blur()
})

const particles = []

function createExplosion(position, color) {
    const particleCount = 30
    const geometry = new THREE.BufferGeometry()
    const positions = new Float32Array(particleCount * 3)
    const velocities = []

    for (let i = 0; i < particleCount; i++) {
        positions[i * 3] = position.x
        positions[i * 3 + 1] = position.y
        positions[i * 3 + 2] = position.z
        velocities.push(new THREE.Vector3(
            (Math.random() - 0.5) * 0.5,
            (Math.random() - 0.5) * 0.5,
            (Math.random() - 0.5) * 0.5
        ))
    }

    geometry.setAttribute('position', new THREE.BufferAttribute(positions, 3))
    const material = new THREE.PointsMaterial({
        color: color,
        size: 0.2,
        transparent: true,
        opacity: 1
    })

    const points = new THREE.Points(geometry, material)
    points.userData.velocities = velocities
    scene.add(points)
    particles.push(points)

    setTimeout(() => {
        scene.remove(points)
        particles.splice(particles.indexOf(points), 1)
        geometry.dispose()
        material.dispose()
    }, 1500)
}

const tick = () => {
    const elapsedTime = clock.getElapsedTime()

    if (keys['KeyA']) azimuth += rotateSpeed
    if (keys['KeyD']) azimuth -= rotateSpeed
    if (keys['KeyW']) polar -= rotateSpeed
    if (keys['KeyS']) polar += rotateSpeed

    polar = Math.max(0.1, Math.min(Math.PI - 0.1, polar))

    camera.position.x = controls.target.x + radius * Math.sin(polar) * Math.sin(azimuth)
    camera.position.y = controls.target.y + radius * Math.cos(polar)
    camera.position.z = controls.target.z + radius * Math.sin(polar) * Math.cos(azimuth)
    camera.lookAt(controls.target)

    raycaster.setFromCamera(mouse, camera)
    const intersects = raycaster.intersectObjects(objects)

    for (const obj of objects) {
        const targetX = obj.basePosition.x + Math.sin(elapsedTime + obj.offset) * 1.5
        const targetY = obj.basePosition.y + Math.cos(elapsedTime + obj.offset) * 1.5
        const targetZ = obj.basePosition.z + Math.sin(elapsedTime * 0.5 + obj.offset) * 1.5
        obj.position.lerp(new THREE.Vector3(targetX, targetY, targetZ), 0.05)
        obj.rotation.y += 0.01
    }

    for (let i = 0; i < particles.length; i++) {
        const points = particles[i]
        const positions = points.geometry.attributes.position.array
        const vels = points.userData.velocities

        for (let j = 0; j < vels.length; j++) {
            positions[j * 3] += vels[j].x
            positions[j * 3 + 1] += vels[j].y
            positions[j * 3 + 2] += vels[j].z
            vels[j].multiplyScalar(0.96)
        }
        points.material.opacity *= 0.98
        points.geometry.attributes.position.needsUpdate = true
    }

    currentIntersect = intersects.length ? intersects[0] : null

    renderer.render(scene, camera)
    window.requestAnimationFrame(tick)
}

tick()